// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for explorer
export const explorerState = $state({
    context: "load",
    rootDir: "personal", // "personal", "team", "recent", "starred", "search", or "tasks"
    records: [],
    selectedRecords: [],
    navHistory: [],
    view: "table",
    loading: false
});